import CallToAction from 'contentful/shared/call_to_action';
import Container from './shared/container';

const CallToActionSection = ({ fields }) => (
  <Container hasReducedPadding>
    <CallToAction content={{ ...fields }} newTab />
  </Container>
);

export default CallToActionSection;
